import {useMutation} from "@tanstack/react-query";

import {editLeadContactMutationOptions} from "./edit-lead-contact.mutation-options";

export function useEditLeadContact(leadId: string, contactId: number) {
  return useMutation(editLeadContactMutationOptions(leadId, contactId));
}
